import { React, useEffect, useState } from "react";
import PlantillaScreen from "../helpers/PlantillaScreen";
import { LoaderScreen } from "../components/LoaderScreen";
import request from "../../Helpers/API";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { MensajeriaListadoContactos } from "./MensajeriaListadoContactos";
import { MensajeriaListadoFiltroGlobal } from "./MensajeriaListadoFiltroGlobal";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { FiltroMensajeriaEnviada } from "./FiltroMensajeriaEnviada";

export const MensajeriaListadoEnviadosScreen = () => {
    const history = useHistory();

    const [mensajeria, setMensajeria] = useState([]);
    const year = new Date().getFullYear();

    const formatoInputDate = (date) => {
        if (!date) return "";

        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    }

    const [filtros, setFiltros] = useState({
        seccion: [],
        fechaInicio: formatoInputDate(new Date(year, 0, 1)),
        fechaFin: formatoInputDate(new Date())
    });



    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    useEffect(() => {
        onExecute();
    }, []);

    const onExecute = () => {
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            let seccionSelect = filtros.seccion

            if (filtros.seccion === "" || filtros.seccion === undefined || filtros.seccion === null || filtros.seccion.length === 0) {
                seccionSelect = 0
            }

            request
                .get(`MensajeriaEnviada/obtenerMensajes?fechainicio=${filtros.fechaInicio}&fechafin=${filtros.fechaFin}&seccion=${seccionSelect}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    console.log(result)
                    setMensajeria(result);
                    // setContactosCobranza(result.cobranza ?? []);
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("MENSAJERIA", error, "error");
                    return;
                });
        });
    };


    const onRegresar = () => {
        history.push("/Mensajeria/Main",
        );
    };

    const onDetalle = (fecha) => {
        history.push("/Mensajeria/Detalle", {
            fecha: fecha,
            seccion: filtros.seccion
        });
    };

    return (
        <PlantillaScreen
            titulo={"MENSAJERIA WHATSAPP"}
            className={"mensajeria-listado-main-screen"}
            className_main={1}
        >
            <LoaderScreen loader={loader} />

            <div className="rotacion-cxc-actions">
                <div
                    className="reporte-recuperacion-responsable-actions-regresar"
                    onClick={() => onRegresar()}
                >
                    <ArrowBackIcon />
                    Regresar
                </div>
            </div>

            <div className="mensajeria-listado-chats">
                <FiltroMensajeriaEnviada
                    filtros={filtros}
                    setFiltros={setFiltros}
                    onCargar={onExecute}
                />

                <div className="mensajeria-listado-tabla-container scroll">
                    <table cellPadding={0} cellSpacing={0}>
                        <thead>
                            <tr>
                                <th>
                                    Envio
                                </th>
                                <th>
                                    <div>Mensajes Enviados</div>
                                </th>
                                <th>
                                    <div>Entregados</div>
                                </th>
                                <th>
                                    <div>Leidos</div>
                                </th>
                                <th>
                                    <div>Contestados</div>
                                </th>
                                <th>
                                    <div>Errores</div>
                                </th>
                                <th>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Usar map para renderizar las filas de la tabla */}
                            {mensajeria.map((item, index) => (
                                <tr>
                                    <td
                                        className="celda-vendedor"

                                    >
                                        {item.envio}
                                    </td>
                                    <td className="ta-right"
                                    // onClick={() => onDetalle("I", item.iddepartamento, item.departamento)}
                                    >
                                        {item.mensajes_enviados}
                                    </td>
                                    <td
                                        // onClick={() => onDetalle("C", item.iddepartamento, item.departamento)}
                                        className="ta-right"
                                    >
                                        {item.entregados}
                                    </td>
                                    <td
                                        // onClick={() => onDetalle("F", item.iddepartamento, item.departamento)}
                                        className="ta-right"
                                    >
                                        {item.leidos}
                                    </td>
                                    <td className="ta-right">{item.contestados}</td>
                                    <td className="ta-right">{item.errores}</td>
                                    <td className="ta-right">
                                        <button
                                            className="detalle-mensaje"
                                            onClick={() => onDetalle(item.envio)}
                                        >Detalle</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr >
                                <td>Total</td>
                                <td className="ta-right">
                                    {mensajeria.reduce((sum, item) => sum + Number(item.mensajes_enviados || 0), 0)}
                                </td>
                                <td className="ta-right">
                                    {mensajeria.reduce((sum, item) => sum + Number(item.entregados || 0), 0)}
                                </td>
                                <td className="ta-right">
                                    {mensajeria.reduce((sum, item) => sum + Number(item.leidos || 0), 0)}
                                </td>
                                <td className="ta-right">
                                    {mensajeria.reduce((sum, item) => sum + Number(item.contestados || 0), 0)}
                                </td>
                                <td className="ta-right">
                                    {mensajeria.reduce((sum, item) => sum + Number(item.errores || 0), 0)}
                                </td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

        </PlantillaScreen>
    )
}